import { render } from "./CentralApp.vue?vue&type=template&id=fe899e5c&ts=true"
import script from "./CentralApp.ts?vue&type=script&lang=ts&external"
export * from "./CentralApp.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__